export const BIG_WIDTH = '1366px'
export const MEDIUM_WIDTH = '1024px'
export const SMALL_WIDTH = '780px'
export const VERY_SMALL_WIDTH = '360px'
